import { render } from "./RiskWatch.vue?vue&type=template&id=7165019e&scoped=true"
import script from "./RiskWatch.vue?vue&type=script&lang=js"
export * from "./RiskWatch.vue?vue&type=script&lang=js"

import "./RiskWatch.vue?vue&type=style&index=0&id=7165019e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7165019e"]])

export default __exports__